'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoRadioWaves = function IoRadioWaves(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm12.5 20c0-3.4 1.6-5 5-5s5 1.6 5 5-1.6 5-5 5-5-1.6-5-5z m-3.7 0c0 1.4 0.3 2.7 1 3.9s1.5 2.2 2.5 2.9l-1.8 2c-0.4-0.4-1-0.8-1.4-1.3-1.9-2-2.8-4.6-2.8-7.5s0.9-5.5 2.8-7.5c0.4-0.5 1-0.9 1.4-1.2l1.8 1.9c-1 0.7-1.9 1.7-2.5 2.9s-1 2.5-1 3.9z m17.5 0c0-1.4-0.4-2.7-1.1-3.9s-1.4-2.2-2.5-2.9l1.8-1.9c0.4 0.3 1 0.7 1.4 1.2 1.9 2 2.8 4.6 2.8 7.5s-0.9 5.5-2.8 7.5c-0.4 0.5-1 0.9-1.4 1.3l-1.8-2c1-0.7 1.9-1.7 2.5-2.9s1-2.5 1-3.9z m-23.8 0c0 2.1 0.5 4.1 1.3 6s2.1 3.4 3.7 4.6l-1.8 1.9c-0.5-0.4-0.9-0.8-1.3-1.2-1.4-1.5-2.4-3.3-3.2-5.1-0.8-2-1.2-4-1.2-6.2s0.4-4.2 1.2-6.2c0.8-1.8 1.8-3.6 3.2-5 0.4-0.5 0.8-0.9 1.3-1.3l1.8 1.9c-0.8 0.6-1.4 1.3-2 2.1s-1.1 1.6-1.6 2.5-0.8 1.9-1 2.9-0.4 2-0.4 3.1z m30 0c0-2.1-0.5-4.1-1.3-6s-2.1-3.4-3.7-4.6l1.8-1.9c0.5 0.4 0.9 0.8 1.3 1.3 1.4 1.4 2.4 3.2 3.2 5 0.8 2 1.2 4 1.2 6.2s-0.4 4.2-1.2 6.2c-0.8 1.8-1.8 3.6-3.2 5.1-0.3 0.3-0.8 0.7-1.3 1.2l-1.8-1.9c1.6-1.2 2.8-2.7 3.7-4.6s1.3-3.9 1.3-6z' })
        )
    );
};

exports.default = IoRadioWaves;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/radio-waves.js
// module id = 2632
// module chunks = 0